import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate, useParams } from 'react-router-dom';
import HeaderPage from '../../../../components/HeaderPage/HeaderPage';
import DefaultContainer from '../../../../components/DefaultContainer/DefaultContainer';
import { main_color_50 } from '../../../../styles/_variables';

import { Spin } from 'antd';

import useHeader from '../../../../hooks/useHeader';
import { useUserStore } from '../../../../store/useUser';
import { getClubAttendanceSummary } from '../../../../service/attendance';
import AttendanceSummaryItem from '../AttendanceSummaryItem/AttendanceSummaryItem';
import { getClubUser } from '../../../../service/clubUser';

const AttendanceSummaryList: React.FC = () => {

  const { id } = useParams();
  const clubId = Number(id);
  
  const userId = useUserStore(state => state.id);
  const profile = useUserStore(state => state.profile);

  const { data: attendanceSummaryList, isFetching: isFetchingSummary } = useQuery(
    ['attendanceSumary'],
    () => getClubAttendanceSummary(clubId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false },
  );

  const { data:clubUser, isFetching: isFetchingClubUser } = useQuery(
    ['clubUser', clubId],
    () => getClubUser(userId, clubId),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false},
  );
  
  const isAdminOrMediator = clubUser?.isCreator === 1 || clubUser?.isMediator === 1;
  const isFetching = isFetchingClubUser || isFetchingSummary;

  useHeader({ header: 'Encontros e listas de presenças' });

  if (!userId) return <DefaultContainer>Você precisa fazer login</DefaultContainer>
  if((!isAdminOrMediator) || (profile === "Clubista")) return <DefaultContainer>Você não tem permissão pra vê essa página</DefaultContainer>;

  return (
      <div>
        <HeaderPage header="Encontros e listas de presenças" bageColor={main_color_50}/>
        <Spin spinning={isFetching}>
          <div>
            {attendanceSummaryList?.map(item => 
              <AttendanceSummaryItem attendanceSummary={item} clubId={clubId} />
            )}
          </div>
        </Spin>
      </div>
  )
}

export default AttendanceSummaryList;